let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("e1z0Z"), load("aZinD"), load("YlVRj"), load("joJy8"), load("aHE9G"), load("1kY5y")]).then(() => parcelRequire('8SUGu'));